// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/WizardServicos_EntrouSemProblemasInput.php
// Do not edit by hand — edit the PHP InputContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * InputContract for POST /wizard_servicos/entrou_sem_problemas/{compromissoId}
 *
 * Marks a compromisso as completed without problems. No body required —
 * compromissoId is a URL path parameter.
 */
import { registerContract } from './validate'

export interface WizardServicos_EntrouSemProblemasInput {}

registerContract('WizardServicos_EntrouSemProblemasInput', {})
